export const BACKEND_HOST = "https://api.technology.arabyouthcenter.org";
